import React from 'react';
import './Optionsicon.css';
import menu from '../assets/images/menu.png';

function Optionsicon({ toggleMenu }) {
  return (
    <div className="icon" onClick={toggleMenu}>
      <img src={menu} alt="Options Icon" className="options-icon-img" />
    </div>
  );
}

export default Optionsicon;
